import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateIngredientSimpleDetailsArgs } from '../graphql/transformers'
import { UPDATE_INGREDIENT_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateIngredientSimpleDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isSimpleDetailsLoading, simpleDetailsError } = useSelector(
    store => store.ingredients.ingredient,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateIngredientSimpleDetailsArgs(data) },
        dispatch,
        UPDATE_INGREDIENT_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isSimpleDetailsLoading, error: simpleDetailsError },
  ]
}

export default useUpdateIngredientSimpleDetailsMutation
